<template>
    <div>
      <custom-animation :data="animationData" class="loading" speed="1" custom="top: 45%; left: 48%;"></custom-animation>
    </div>
  </template>
  
  <script>
  import CustomAnimation from '../CustomAnimationWithLottieWithModal';
  import loading from './loading.json';
  
  export default {
    components: {
      CustomAnimation
    },
    data() {
      return {
        animationData: loading
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .loading {
    transform: scale(2);
  }
  </style>
  